"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var Query_1 = require("../Query");

var QueryTransform =
/** @class */
function (_super) {
  __extends(QueryTransform, _super);

  function QueryTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  QueryTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    var response = queryResponse;

    if (queryResponse) {
      var queryTransformOptions = this.options.queryTransformOptions;

      if (queryTransformOptions) {
        var query = new Query_1.Query(queryTransformOptions, this.translationHelper, (this.callStackLevel || 1) + 1);
        response = query.execute(__assign(__assign({}, executionOptions), {
          responseContext: response
        }));
      }
    }

    return response;
  };

  return QueryTransform;
}(BaseTransform_1.BaseTransform);

exports.QueryTransform = QueryTransform;